<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
  <!--<div class="card bg-secondary text-white flex-shrink">-->
  <div class="card border border-secondary text-secondary flex-shrink">
    <div class="card-body p-4">
      <slot name="body"></slot>
    </div>

    <div class="flex flex-row gap-4 justify-end px-4 pb-4">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardComponent"
};
</script>

<style scoped>

</style>